
export default {
    'bhz': {
        isEstapar: false,
        typeCard: true,
        balanceCad: true,
        city: 'BHZ',
        cityName: 'Belo Horizonte',
        product: 'Rotativo',
        productPlural: 'Rotativos',
        service: 'Rotativo Digital'
    },
    'ftz': {
        isEstapar: false,
        typeCard: true,
        balanceCad: true,
        city: 'FTZ',
        cityName: 'Fortaleza',
        product: 'Cartão',
        productPlural: 'Cartões',
        service: 'Faixa Azul'
    },
    'ssa': {
        isEstapar: false,
        typeCard: true,
        balanceCad: false,
        city: 'SSA',
        cityName: 'Salvador',
        product: 'Crédito',
        productPlural: 'Créditos',
        service: 'Zona Azul'
    },
    'cwb': {
        isEstapar: false,
        typeCard: true,
        balanceCad: true,
        city: 'CWB',
        cityName: 'Curitiba',
        product: 'Crédito',
        productPlural: 'Créditos',
        service: 'Zona Azul'
    },
    'cjz': {
        isEstapar: false,
        typeCard: true,
        balanceCad: true,
        city: 'CJZ',
        cityName: 'Cajazeiras',
        product: 'Crédito',
        productPlural: 'Créditos',
        service: 'Zona Azul'
    },
    'jdn': {
        isEstapar: false,
        typeCard: true,
        balanceCad: true,
        city: 'JDN',
        cityName: 'Juazeiro do Norte',
        product: 'Crédito',
        productPlural: 'Créditos',
        service: 'Zona Azul'
    },
    'mon': {
        isEstapar: false,
        typeCard: true,
        balanceCad: true,
        city: 'MON',
        cityName: 'Mongaguá',
        product: 'Crédito',
        productPlural: 'Créditos',
        service: 'Zona Azul'
    },
    'sgr': {
        isEstapar: false,
        typeCard: true,
        balanceCad: true,
        city: 'SGR',
        cityName: 'Salgueiro',
        product: 'Crédito',
        productPlural: 'Créditos',
        service: 'Zona Azul'
    },
    'ame': {
        isEstapar: true,
        typeCard: false,
        balanceCad: true,
        city: 'AME',
        cityName: 'Americana',
        product: 'CAD',
        productPlural: 'CADs',
        service: 'Zona Azul Digital'
    },
    'ara': {
        isEstapar: true,
        typeCard: false,
        balanceCad: true,
        city: 'ARA',
        cityName: 'Araraquara',
        product: 'CAD',
        productPlural: 'CADs',
        service: 'Zona Azul Digital'
    },
    'ita': {
        isEstapar: true,
        typeCard: false,
        balanceCad: true,
        city: 'ITA',
        cityName: 'Itatiba',
        product: 'CAD',
        productPlural: 'CADs',
        service: 'Zona Azul Digital'
    },
    'jac': {
        isEstapar: true,
        typeCard: false,
        balanceCad: true,
        city: 'JAC',
        cityName: 'Jacareí',
        product: 'CAD',
        productPlural: 'CADs',
        service: 'Zona Azul Digital'
    },
    'jzf': {
        isEstapar: true,
        typeCard: false,
        balanceCad: true,
        city: 'JZF',
        cityName: 'Juiz de Fora',
        product: 'CAD',
        productPlural: 'CADs',
        service: 'Zona Azul Digital'
    },
    'lim': {
        isEstapar: true,
        typeCard: false,
        balanceCad: true,
        city: 'LIM',
        cityName: 'Limeira',
        product: 'CAD',
        productPlural: 'CADs',
        service: 'Zona Azul Digital'
    },
    'mog': {
        isEstapar: true,
        typeCard: false,
        balanceCad: true,
        city: 'MOG',
        cityName: 'Mogi das Cruzes',
        product: 'CAD',
        productPlural: 'CADs',
        service: 'Zona Azul Digital'
    },
    'ric': {
        isEstapar: true,
        typeCard: false,
        balanceCad: true,
        city: 'RIC',
        cityName: 'Rio Claro',
        product: 'CAD',
        productPlural: 'CADs',
        service: 'Zona Azul Digital'
    },
    'sbc': {
        isEstapar: true,
        typeCard: false,
        balanceCad: true,
        city: 'SBC',
        cityName: 'São Bernardo do Campo',
        product: 'CAD',
        productPlural: 'CADs',
        service: 'Zona Azul Digital'
    },
    'sbo': {
        isEstapar: true,
        typeCard: false,
        balanceCad: true,
        city: 'SBO',
        cityName: 'Santa Bárbara D\'Oeste',
        product: 'CAD',
        productPlural: 'CADs',
        service: 'Zona Azul Digital'
    },
    'sca': {
        isEstapar: true,
        typeCard: false,
        balanceCad: false,
        city: 'SCA',
        cityName: 'São Carlos',
        product: 'CAD',
        productPlural: 'CADs',
        service: 'Zona Azul Digital'
    },
    'sbv': {
        isEstapar: true,
        typeCard: false,
        balanceCad: false,
        city: 'SBV',
        cityName: 'São João da Boa Vista',
        product: 'CAD',
        productPlural: 'CADs',
        service: 'Zona Azul Digital'
    },
    'ssg': {
        isEstapar: true,
        typeCard: true,
        balanceCad: false,
        city: 'SSG',
        cityName: 'São Gabriel',
        product: 'Crédito',
        productPlural: 'Créditos',
        service: 'Área Azul'
    },
    'sta': {
        isEstapar: true,
        typeCard: false,
        balanceCad: true,
        city: 'STA',
        cityName: 'Santo André',
        product: 'CAD',
        productPlural: 'CADs',
        service: 'Zona Azul Digital'
    },
    'tau': {
        isEstapar: true,
        typeCard: false,
        balanceCad: true,
        city: 'TAU',
        cityName: 'Taubaté',
        product: 'CAD',
        productPlural: 'CADs',
        service: 'Zona Azul Digital'
    },
    'sao': {
        isEstapar: true,
        typeCard: true,
        balanceCad: true,
        city: 'SAO',
        cityName: 'São Paulo',
        product: 'CAD',
        productPlural: 'CADs',
        service: 'Zona Azul Digital'
    },
    'mau': {
      isEstapar: true,
      typeCard: true,
      balanceCad: true,
      city: 'MAU',
      cityName: 'Mauá',
      product: 'CAD',
      productPlural: 'CADs',
      service: 'Zona Azul Digital'
  },
    'mcl': {
        isEstapar: true,
        typeCard: false,
        balanceCad: true,
        city: 'MCL',
        cityName: 'Montes Claros',
        product: 'Real',
        productPlural: 'Reais',
        service: 'Zona Azul Digital'
    },
    'default': {
        isEstapar: true,
        typeCard: true,
        balanceCad: true,
        city: 'SAO',
        cityName: 'São Paulo',
        product: 'CAD',
        productPlural: 'CADs',
        service: 'Zona Azul Digital'
    }
}
